import type { Locale } from 'date-fns';
import arSA from 'date-fns/locale/ar-SA';
import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import hi from 'date-fns/locale/hi';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import pt from 'date-fns/locale/pt';
import ptBR from 'date-fns/locale/pt-BR';
import zhCN from 'date-fns/locale/zh-CN';

/**
 * Maps TMOS `LanguageProvider` ids to date-fns locales for formatted dates/times (calendar, agenda widget, etc.).
 * Week boundaries: pass the same `Locale` to `startOfWeek` / `endOfWeek` as `{ locale }` (see `localePreferences.ts`).
 */
const BY_LANGUAGE_ID: Record<string, Locale> = {
  'en-US': enUS,
  'en-GB': enGB,
  'de-DE': de,
  'fr-FR': fr,
  'es-ES': es,
  'it-IT': it,
  'pt-BR': ptBR,
  'pt-PT': pt,
  'ja-JP': ja,
  'ko-KR': ko,
  'zh-CN': zhCN,
  'ar-SA': arSA,
  'hi-IN': hi,
  // date-fns has no mr locale; Hindi is closer than English for Indian users
  'mr-IN': hi
};

export function getDateFnsLocale(languageId: string): Locale {
  return BY_LANGUAGE_ID[languageId] ?? enUS;
}
